import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/CrawlingModuleInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/crawlingmodule`;
	}
	listCrawlingModulesByProject(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/projectid`, { projectId: e }));
	}
	async getMaestroDownloadLink() {
		let e = await this.api.get(this.buildPath(`${n.baseUrl}/download`));
		try {
			return new URL(`${e}/Maestro-setup.exe`);
		} catch {
			return;
		}
	}
};
export { n as CrawlingModuleInternalResource };

//# sourceMappingURL=CrawlingModuleInternalResource.js.map